import postOfficeTemplate from '@post-office/team-package--i18n--post-office-template/i18n/nl.json';
import growth from '@post-office/team-package--i18n--growth/i18n/nl.json';
import testMessages from '@post-office/team-package--i18n--test-messages/i18n/nl.json';

export default {
	...postOfficeTemplate,
	...growth,
	...testMessages
}
